import React, { Component } from 'react';
const products = [{
  name: 'CHMER CNC Series CM655C Die Sinker EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/fe7219e3b7e2e84248562a8585d8bc17/large-0000064_chmer-cnc-series-cm655c.jpg',
  href: '/listings/4738634-chmer-cnc-series-cm655c-die-sinker-edm'
}, {
  name: 'CHMER CNC Series CM865C Die Sinker EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/45a8f89388d00d11a637031052f4bff5/large-0000065_chmer-cnc-series-cm865c.jpg',
  href: '/listings/4738633-chmer-cnc-series-cm865c-die-sinker-edm'
}, {
  name: 'CHMER CNC Series CM1065C Die Sinker EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/dc2fb29092a511324797813f0ae50c77/large-0000066_chmer-cnc-series-cm1065c.jpg',
  href: '/listings/4738632-chmer-cnc-series-cm1065c-die-sinker-edm'
}, {
  name: 'CHMER CNC Series CM1265C Die Sinker EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/bacf34cdadbe6eaf408818250a9d16de/large-0000067_chmer-cnc-series-cm1265c.jpg',
  href: '/listings/4738635-chmer-cnc-series-cm1265c-die-sinker-edm'
}, {
  name: 'CHMER CNC Series CM1475C Die Sinker EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/0d6db72f950f0864b070d36f7700c095/large-0000068_chmer-cnc-series-cm1475c.jpg',
  href: '/listings/4738643-chmer-extra-large-cnc-series-cm1475c-die-sinker'
}, {
  name: 'CHMER CNC Series CM1675C Die Sinker EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/7fc8c3a09697510b7ad8d6c3b5479acc/large-0000070_chmer-cnc-series-cm1876c.jpg',
  href: '/listings/4738644-chmer-extra-large-cnc-series-cm1675c-die-sinker'
}, {
  name: 'CHMER CNC Series CM2076C Die Sinker EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/a92dfe3d0adaae08830d86c9347cb2b3/large-0000071_chmer-cnc-series-cm2076c.jpg',
  href: '/listings/4738646-chmer-extra-large-cnc-series-cm2076c-die-sinker'
}, {
  name: 'CHMER CNC Series CM1875C Dual Ram',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/5e5859381935b8f6535f5e8b3ca882e7/large-0000072_chmer-cnc-series-cm3076c.jpg',
  href: '/listings/4738645-chmer-extra-large-cnc-series-cm1875c-die-sinker-shown-with-opt-dual-ram'
}, {
  name: 'CHMER CNC Series CM3076C Dual Ram',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/bdd29d7bdcdb640824aa3d7943f83b8f/large-chmer-cnc-series-cm-3076-c.jpg',
  href: '/listings/4738647-chmer-cnc-series-cm3076c-photo-shown-with-opt-dual-ram'
}];
export function ChmerLargeCNCSection() {
  return <section data-id="element-1931">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-1932">
        <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-1933">
          Chmer Large CNC Series
        </h2>
      </div>
      <div className="bg-white p-6 md:p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-1934">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-1935">
          {products.map((product, pIndex) => <div key={pIndex} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-1936">
              <a href="/m7_view_item.html" className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 block" data-id="element-1937">
                <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500 block" data-id="element-1938" />
              </a>
              <div className="p-5 flex flex-col flex-grow" data-id="element-1939">
                <a href="/m7_view_item.html" className="no-underline" data-id="element-1940">
                  <h3 className="text-base font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-1941">
                    {product.name}
                  </h3>
                </a>
                <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col space-y-2" data-id="element-1942">
                  <a href={`/ContactPeakMachineSales.html?i515589:default[Product%20Title]=${encodeURIComponent(product.name)}`} className="inline-flex items-center justify-center w-full bg-navy text-white px-4 py-2 rounded-md font-bold text-sm hover:bg-orange transition-colors no-underline" data-id="element-1943">
                    Request for Quote
                  </a>
                  <a href="/m7_view_item.html" className="inline-flex items-center justify-center w-full bg-gray-100 text-navy px-4 py-2 rounded-md font-bold text-sm hover:bg-gray-200 transition-colors no-underline" data-id="element-1944">
                    More Information
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}